import OrderStates from './StaticDocuments'

export default OrderStates;


// WEBPACK FOOTER //
// ./src/components/Query/StaticDocuments/index.ts